import { Component, OnInit, OnDestroy } from '@angular/core';
import { camps } from '../../../models/models.generated';
import { CampDefinitionApiService } from '../../../services/api/camp-definition-api.service';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CampsDetailsFormBuilder } from './camp-details-form-builder';
import { CampsDetailsFormStateService } from './camp-details-form-state-service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-camp-details',
    host: { 'data-testid': 'camp-details-page' },
    templateUrl: './camp-details.component.html',
    styleUrls: ['./camp-details.component.scss'],
    standalone: false
})
export class CampDetailsComponent implements OnInit, OnDestroy {


    public model: camps.CampDefinitionDetails;
    public context: camps.CampDefinitionCreationContext;

    public form: UntypedFormGroup = null;

    private subscription = new Subscription();


    constructor(private service: CampDefinitionApiService,
        private activatedRoute: ActivatedRoute,
        private formBuilder: CampsDetailsFormBuilder,
        public state: CampsDetailsFormStateService) {

    }

    ngOnInit(): void {

        this.service.getCreationContext().subscribe(x => {
            this.context = x.value;
        });

        this.subscription.add(
            this.activatedRoute.params.subscribe(params => {
                if (params.id) {
                    this.loadDetails(params.id, null);
                }
            }));


        this.subscription.add(
            this.state.sessionChanged.subscribe(x => {
                this.loadDetails(this.model.id, x);
            }));

        this.subscription.add(
            this.state.discountChanged.subscribe(() => {
                this.loadDetails(this.model.id, null);
            }));

        this.subscription.add(
            this.state.sessionRemoved.subscribe(() => {
                this.loadDetails(this.model.id, null);
            }));
    }

    loadDetails(id: camps.Guid, sessionToExpand: string): any {
        this.service.get(id).subscribe(x => {
            this.model = x.value;

            this.state.setStatus(this.model.status);
            this.state.setType(this.model.type);
            this.initForm(sessionToExpand);

        });
    }

    private initForm(sessionToExpand: string) {
        this.form = this.formBuilder.build(this.model, sessionToExpand);
        if (!sessionToExpand) {
            var arr = this.form.get('sessionGroups.items') as UntypedFormArray;
            var first = arr.controls[0] as UntypedFormGroup;

            if (first)
                first.controls['active'].setValue(true);
        }
    }

    public get discountsForm(): UntypedFormGroup {
        return this.form.controls['discounts'] as UntypedFormGroup;
    }

    public get pricingDiscountsForm(): UntypedFormGroup {
        return this.form.controls['pricingDiscounts'] as UntypedFormGroup;
    }

    public get sessionGroupForm(): UntypedFormGroup {
        return this.form.controls['sessionGroups'] as UntypedFormGroup;
    }

    public get basicInfoForm(): UntypedFormGroup {
        return this.form.controls['basicInfo'] as UntypedFormGroup;
    }

    public get visibilityForm(): UntypedFormGroup {
        return this.form.controls['visibility'] as UntypedFormGroup;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.state.clear();
    }
}
